import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/tokens.css';
import './styles/index.css';
import { App } from './App.js';

const root = document.getElementById('root');
if (!root) throw new Error('root element not found');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
